import { BackupInfraService } from './backupInfraService';

/** Mesmo contrato do backup: nasceu direta, então os códigos de erro dizem o que aconteceu. */
const ferramentasEpisService = new BackupInfraService('ferramentas-epis', 'ferramentas_epis', {
  IXC_DIRECT_DISABLED: 'Esta empresa não tem lista de ferramentas e EPIs.',
  IXC_UNAVAILABLE: 'O IXC não respondeu. O saldo mostrado pode estar desatualizado ou ausente.',
  EMPRESA_INDEFINIDA: 'Selecione uma única empresa: saldo de almoxarifado não se soma entre bases diferentes.',
});

export default ferramentasEpisService;
